import { ComponentType } from 'react'
import { WorkspaceApiKeyScope } from '@/types/workspace'
import { PlatformEventsExample } from './PlatformEventsExample'

export type ApiKeyExampleProps = {
  keyValue: string
}

export type ApiKeyScopeConfig = {
  value: WorkspaceApiKeyScope
  labelId: string
  descriptionId: string
  endpoint: string
  ExampleComponent: ComponentType<ApiKeyExampleProps>
}

export const API_KEY_SCOPE_CONFIG: Record<
  WorkspaceApiKeyScope,
  ApiKeyScopeConfig
> = {
  [WorkspaceApiKeyScope.PlatformEvents]: {
    value: WorkspaceApiKeyScope.PlatformEvents,
    labelId: 'workspace.apiKeys.scope.platformEvents',
    descriptionId: 'workspace.apiKeys.scope.platformEvents.description',
    endpoint: '/api/v1/external/events/',
    ExampleComponent: PlatformEventsExample
  }
  // [WorkspaceApiKeyScope.VlmEvents]: {
  //   value: WorkspaceApiKeyScope.VlmEvents,
  //   labelId: 'workspace.apiKeys.scope.vlmEvents',
  //   descriptionId: 'workspace.apiKeys.scope.vlmEvents.description',
  //   endpoint: '/api/v1/vlm-events',
  //   ExampleComponent: VlmEventsExample
  // }
}

export const SCOPE_OPTIONS = Object.values(API_KEY_SCOPE_CONFIG)

export const getScopeConfig = (
  scope: WorkspaceApiKeyScope
): ApiKeyScopeConfig => API_KEY_SCOPE_CONFIG[scope]
